import styles from './LoadingBlock.module.css';

/**
 * Static placeholder while content loads (DESIGN.md §5: wash blocks, no shimmer).
 * Screen readers hear `label` once instead of the blocks.
 */
export function LoadingBlock({ label, rows = 3 }: { label: string; rows?: number }) {
  return (
    <div className={styles.block} role="status">
      <span className={styles.visuallyHidden}>{label}</span>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className={styles.row} aria-hidden="true" />
      ))}
    </div>
  );
}
